if (typeof ArticleToc !== 'function') {
  class ArticleToc extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.kt-journal-toc__list');
      this.mobileToggle = this.querySelector('.kt-journal-toc__mobile-toggle');

      const contentRoot = this.closest('.kt-section--article-body')
        ?.querySelector('.kt-article-content');

      if (!contentRoot) {
        this.hidden = true;
        return;
      }

      const headings = Array.from(contentRoot.querySelectorAll('h2'));

      if (headings.length === 0) {
        this.hidden = true;
        return;
      }

      this.items = headings.map((heading, index) => {
        if (!heading.id) {
          heading.id = this.slugify(heading.textContent) || `journal-section-${index + 1}`;
        }

        const li = document.createElement('li');
        li.dataset.n = String(index + 1).padStart(2, '0');

        const a = document.createElement('a');
        a.href = '#' + heading.id;
        a.textContent = heading.textContent;
        a.addEventListener('click', (e) => {
          e.preventDefault();
          document.getElementById(heading.id).scrollIntoView({ behavior: 'smooth' });
          this.list.classList.remove('open');
        });
        li.appendChild(a);

        this.list.appendChild(li);
        return { li, heading };
      });

      if (this.items.length > 0) {
        this.items[0].li.classList.add('active');
      }

      this.mobileToggle.hidden = false;
      this.mobileToggle.addEventListener('click', () => {
        this.list.classList.toggle('open');
      });

      this._onScroll = () => this.updateActive();
      window.addEventListener('scroll', this._onScroll, { passive: true });
    }

    slugify(text) {
      return (text || '')
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '');
    }

    updateActive() {
      let current = this.items[0];
      for (const item of this.items) {
        if (item.heading.getBoundingClientRect().top < 140) {
          current = item;
        }
      }
      for (const item of this.items) {
        item.li.classList.toggle('active', item === current);
      }
    }

    disconnectedCallback() {
      if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
    }
  }

  customElements.define('article-toc', ArticleToc);
}
